import { ExtraGuestGeneratedPolicies } from '~/types/roomPolicy';

interface StructuredResult {
  isStructured: true;
  data: ExtraGuestGeneratedPolicies;
}

interface UnstructuredResult {
  isStructured: false;
  data: null;
}

type ParseResult = StructuredResult | UnstructuredResult;

function isExtraGuestGeneratedPolicies(value: unknown): value is ExtraGuestGeneratedPolicies {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const obj = value as Record<string, unknown>;

  return (
    Array.isArray(obj.maximumRoomCapacities) &&
    Array.isArray(obj.packageInclusions) &&
    Array.isArray(obj.extraGuestGeneratedPolicyItems) &&
    Array.isArray(obj.additionalPolicyNotes)
  );
}

export default function parseRoomPolicyDescription(description: string): ParseResult {
  if (!description || typeof description !== 'string') {
    return { isStructured: false, data: null };
  }

  try {
    const parsed = JSON.parse(description);

    if (isExtraGuestGeneratedPolicies(parsed)) {
      const data: ExtraGuestGeneratedPolicies = {
        ...parsed,
        beddingConfiguration: typeof parsed.beddingConfiguration === 'string' ? parsed.beddingConfiguration : '',
        beddingConfigurationExtras: Array.isArray(parsed.beddingConfigurationExtras)
          ? parsed.beddingConfigurationExtras.filter((item): item is string => typeof item === 'string')
          : [],
      };
      return { isStructured: true, data };
    }

    return { isStructured: false, data: null };
  } catch {
    return { isStructured: false, data: null };
  }
}
